class StringComparer {
    static descending(value1, value2) {
        return value2.localeCompare(value1);
    }
    static ascending(value1, value2) {
        return value1.localeCompare(value2);
    }
}

class NumberComparer {
    static descending(value1, value2) {
        return value2 - value1;
    }
    static ascending(value1, value2) {
        return value1 - value2;
    }
}

export { NumberComparer as N, StringComparer as S };
//# sourceMappingURL=numberComparer-47fa4d1b.js.map
